import { mainPalette } from '../palettes';

export default {
  root: {
    color: mainPalette.icon,
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.03)'
    }
  }
};
